import { DocumentUploadState } from "./types";
import { generateId } from "utils/unsaved-changes/dialogRegistry";
import { getEditorKeyByNote } from "./util";
export const removeEditorsNotInFetch = (state, fetchedIds) => {
    const existingEditors = state.editors ?? {};
    const nextEditors = {};
    Object.entries(existingEditors).forEach(([key, note]) => {
        const existingId = note?.id;
        if (existingId && !fetchedIds.has(existingId)) {
            if (state.currentNoteKey === key) {
                state.currentNoteKey = undefined;
            }
            return;
        }
        nextEditors[key] = note;
    });
    return nextEditors;
};
const isFailedDocumentStatus = (status) => status === DocumentUploadState.FILE_UPLOAD_STATUS_FAILED
    || status === DocumentUploadState.FILE_UPLOAD_STATUS_SCAN_FAILED
    || status === DocumentUploadState.FILE_UPLOAD_STATUS_FILE_INVALID;
const filterFailedDocuments = (note) => {
    const documents = Array.isArray(note.documents)
        ? note.documents
        : [];
    return {
        ...note,
        documents: documents.filter((doc) => !isFailedDocumentStatus(doc.status))
    };
};
export const mergeFetchedNotesIntoEditors = (state, nextEditors, notes) => {
    notes.forEach((note) => {
        const existingKey = getEditorKeyByNote(nextEditors, note);
        const id = existingKey ?? generateId();
        const filteredNote = filterFailedDocuments(note);
        const noteWithKey = { noteKey: id, ...filteredNote };
        nextEditors[id] = noteWithKey;
    });
};
const findUpsertEditorKey = (existingEditors, note, requestNoteKey) => {
    if (requestNoteKey && existingEditors[requestNoteKey]) {
        return requestNoteKey;
    }
    if (note.noteKey && existingEditors[note.noteKey]) {
        return note.noteKey;
    }
    return getEditorKeyByNote(existingEditors, note);
};
export const mergeUpsertedNotesIntoEditors = (state, action, selectFirstCurrentNoteIfMissing) => {
    const { meta, payload } = action;
    const existingEditors = state.editors ?? {};
    const nextEditors = { ...existingEditors };
    const requestNotes = meta?.arg?.originalArgs?.notes ?? [];
    payload.notes.forEach((note, index) => {
        const requestNoteKey = requestNotes[index]?.noteKey;
        const id = findUpsertEditorKey(existingEditors, note, requestNoteKey);
        if (!id) {
            return;
        }
        const filteredNote = filterFailedDocuments(note);
        nextEditors[id] = { ...filteredNote, noteKey: id };
    });
    state.editors = nextEditors;
    if (state.currentNoteKey && !state.editors?.[state.currentNoteKey]) {
        state.currentNoteKey = undefined;
    }
    selectFirstCurrentNoteIfMissing(state);
};
